import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import help_icon from '../../assets/help_icon.png';
import '../../css/ServiceCompanyDetails.css';
import RegistrationProgressBar from "../components/RegistrationProgressBar";

function ServiceCompanyDetails() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        companyWebsite: '',
        serviceCity: '',
        projectSite: '',
        realtorEmail: '',
        socialProfiles: {
            yelp: '',
            homeAdvisor: '',
            thumbtack: '',
            taskRabbit: '',
            other: ''
        }
    });
    const [error, setError] = useState('');

    const handleInputChange = (field, value) => {
        if (field.includes('.')) {
            // TODO:  I believe these are all url fields.  verify first, then add https if not existing
            const [parent, child] = field.split('.');
            setFormData(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.serviceCity) {
            setError('Primary service city is required');
            return;
        }

        try {
            setError('');
            const response = await axios.post('/api/service_provider_details', formData);

            if (response.status === 200) {
                navigate("/service-company/" + response.data.link_hash);
            } else {
                throw new Error('Unexpected response status');
            }
        } catch (error) {
            setError( 'Failed to submit the form. Please try again.');
        }
    };

    const renderInput = (label, field, placeholder, required = false, helpIcon = null, helpText = null, type = "text") => {
        const inputId = `${field}-input`;
        return (
            <div className="serviceCompanyDetailsInputContainer">
                {label && (
                    <div className="serviceCompanyDetailsLabelContainer">
                        <label htmlFor={inputId} className="serviceCompanyDetailsInputLabel">
                            {label} {required && <span className="serviceCompanyDetailsRequired">*</span>}
                        </label>
                        {helpIcon && (
                            <div className="tooltip">
                                <img
                                    src={helpIcon}
                                    alt="Help Icon"
                                    className="serviceCompanyDetailsHelpIcon"
                                />
                                <div className="tooltiptext">{helpText}</div>
                            </div>
                        )}
                    </div>
                )}
                <div className="serviceCompanyDetailsTextFieldContainer">
                    <div className="serviceCompanyDetailsInputWrapper">
                        <input
                            type={type}
                            id={inputId}
                            className="serviceCompanyDetailsInput"
                            placeholder={placeholder}
                            value={field.includes('.') ?
                                formData[field.split('.')[0]][field.split('.')[1]] :
                                formData[field]}
                            onChange={(e) => handleInputChange(field, e.target.value)}
                            aria-label={label}
                            required={required}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="serviceCompanyDetailsContainer">
            <RegistrationProgressBar elements={[{icon: "check", label: "Select your trades"}, {icon: "bar_blue"}, {icon: "dot_blue", label: "Company information"}]}/>
            <section className="serviceCompanyDetailsFormSection">
                <div className="serviceCompanyDetailsFormTitle">Tell Us More About Your Company</div>

                <form onSubmit={handleSubmit} className="serviceCompanyDetailsForm">
                    <div className="serviceCompanyDetailsFormRow">
                        {renderInput("Company Website", "companyWebsite", "Company Website")}
                        {renderInput("Primary Service City", "serviceCity", "City Name", true)}
                    </div>

                    <div className="serviceCompanyDetailsFormRow">
                        {renderInput("Recent Project Site", "projectSite", "Realtor-hired preferred")}
                        {renderInput("Realtor's Email", "realtorEmail", "Enter realtor's email", false, help_icon, "Your connections with Realtors will boost your credibility", "email")}
                    </div>

                    <div className="serviceCompanyDetailsSocialSection">
                        <div className="serviceCompanyDetailsSocialHeader">
                            <h2 className="serviceCompanyDetailsSocialTitle">Online Profiles</h2>
                            <div className="tooltip">
                                <img
                                    src={help_icon}
                                    alt="Help Icon"
                                    className="serviceCompanyDetailsHelpIcon"
                                />
                                <div className="tooltiptext">Your public profiles help us verify your business information.</div>
                            </div>
                        </div>
                        <div className="serviceCompanyDetailsSocialInputs">
                            {renderInput("", "socialProfiles.yelp", "Copy and paste your Yelp profile link")}
                            {renderInput("", "socialProfiles.homeAdvisor", "Copy and paste your HomeAdvisor profile link")}
                            {renderInput("", "socialProfiles.thumbtack", "Copy and paste your Thumbtack profile link")}
                            {renderInput("", "socialProfiles.taskRabbit", "Copy and paste your TaskRabbit profile link")}
                            {renderInput("", "socialProfiles.other", "Copy and paste other online profile link")}
                        </div>
                    </div>

                    {error && <div className="serviceCompanyDetailsError">{error}</div>}
                    <div className="serviceCompanyDetailsFormActions">
                        <a href="/service-company-trades">
                            <button type="button" className="serviceCompanyDetailsBackButton">Back</button>
                        </a>
                        <button type="submit" className="serviceCompanyDetailsSubmitButton" disabled={!formData.serviceCity}>Save and Continue</button>
                    </div>
                </form>
            </section>
        </div>
    );
}

export default ServiceCompanyDetails;
